export type PayPalButtonsInstance = {
  isEligible?: () => boolean;
  render: (container: HTMLElement) => Promise<void>;
  close?: () => Promise<void> | void;
};

export type PayPalNamespace = {
  Buttons: (options: Record<string, unknown>) => PayPalButtonsInstance;
};

export const getPayPalWindow = () =>
  window as Window & {
    paypal?: PayPalNamespace;
  };

const paypalScriptErrorSuppressionMs = 8000;
let suppressPayPalScriptErrorsUntil = 0;
let paypalScriptErrorSuppressionInstalled = false;

const shouldSuppressPayPalScriptError = (message?: string, error?: unknown) =>
  Date.now() < suppressPayPalScriptErrorsUntil &&
  message === 'Script error.' &&
  !error;

export const suppressExpectedPayPalScriptErrors = () => {
  suppressPayPalScriptErrorsUntil = Date.now() + paypalScriptErrorSuppressionMs;
};

export const installPayPalScriptErrorSuppression = () => {
  if (typeof window === 'undefined' || paypalScriptErrorSuppressionInstalled) {
    return;
  }

  paypalScriptErrorSuppressionInstalled = true;

  window.addEventListener(
    'error',
    (event) => {
      if (!shouldSuppressPayPalScriptError(event.message, event.error)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message =
      typeof reason === 'string'
        ? reason
        : reason instanceof Error
          ? reason.message
          : '';

    if (!shouldSuppressPayPalScriptError(message, reason instanceof Error ? reason : undefined)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  });
};
